import { render } from "./DiskUsage.html?vue&type=template&id=5d9b49d2&ts=true"
import script from "./DiskUsage.ts?vue&type=script&lang=ts"
export * from "./DiskUsage.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__